const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const dateToUTCParam = require("./util/date-to-param").dateToUTCParam;

const FinishedActivitiesActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

FinishedActivitiesActions.fetchData.listen(function(period, users) {
  let params = {
    start_date: dateToUTCParam(period.startDate),
    end_date: dateToUTCParam(period.endDate),
    users: users
  };

  biAPI.fetch("/finished_activities", params, this.completed, this.failed);
});

module.exports = FinishedActivitiesActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/finished-activities-actions.js